import styled from "styled-components";

import { colors } from "../../../../consts";
import { WrapperContainer } from "../../../../components";
import { TableWrapper } from "../../../../components/Table/styled";

export const DeviceImageContainer = styled(WrapperContainer)`
  width: 40px;
  height: 40px;

  border-radius: 8px;
  background: ${colors.ISABELLINE_DARKER};

  min-width: 40px;

  img {
    height: 80%;
  }
`;

export const FWUCampaignTableWrapper = styled(WrapperContainer)`
  ${TableWrapper} {
    overflow: visible;
  }
`;

export const EmptyCircle = styled(WrapperContainer)`
  width: 19px;
  height: 19px;
  border: 2px solid ${colors.RAISIN_10};
  border-radius: 100%;

  margin-left: 3px;
`;
